module.exports = __webpack_public_path__ + "static/media/undraw_Charts_re_5qe9.bf3c4e27.png";